﻿

export function componentInitialize(components) {

    $(document).ready(function () {
        
        for (var i = 0; i < components.length; i++) {
            var v = components[i].v;
            var el = $("[data-pui-component='" + components[i].name + "']");

            if (el.length > 0) {
                el.removeClass("initializing");
                v.$mount(el[0]);
            }
        }
    });

};